<template>
  <base-layout :pageTitle="pageTitle" :pageDefaultBackLink="backDefaultUrl">
    <!-- <add-edit-task-form @save-task="saveTask"></add-edit-task-form> -->
    <add-edit-tag-form :formType="formType"></add-edit-tag-form>
  </base-layout>
</template>

<script>
import AddEditTagForm from "@/components/tags/AddEdit";
import BaseLayout from "@/components/base/BaseLayout.vue";
export default {
  components: { BaseLayout, AddEditTagForm },
  name: "AddEditTag",
  props: {
    formType: {
      type: String,
      default: "Create",
    },
  },
  computed: {
    pageTitle() {
      return this.translate(this.formType) + " " + this.translate("Tag");
    },
    backDefaultUrl() {
      const { href } = this.$router.resolve({ name: "Interventions" });
      return href;
    },
  },
  methods: {
    //   saveTask(taskData) {
    //   }
  },
};
</script>

<style>
</style>